import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, radius } = redesignTheme;

export const useTypingIndicatorStyles = makeStyles(() => ({
  typingIndicator: {
    backgroundColor: colors.chatBubbleAssistant,
    padding: '12px 16px',
    borderRadius: radius.sm,
    maxWidth: 80,
    alignSelf: 'flex-start',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    '& span': {
      animation: '$blink 1.4s infinite',
      fontSize: 20,
      lineHeight: 1,
      color: colors.chatMessageText,
      '&:nth-child(2)': {
        animationDelay: '0.2s',
      },
      '&:nth-child(3)': {
        animationDelay: '0.4s',
      },
    },
  },
  '@keyframes blink': {
    '0%, 60%, 100%': {
      opacity: 0.3,
    },
    '30%': {
      opacity: 1,
    },
  },
}));
